import type { RadiusCircle } from '@openx/types/targeting/geographic.ts';
import type { TFunction } from 'i18next';
import type { InvalidItemsError, ValidationResult } from '../../../shared/BulkAdd/types.ts';
import { splitCoordinates } from './splitCoordinates.ts';
import { validateCoordinates } from './validateCoordinates.ts';

export const validateBulkCircles = (
  t: TFunction,
  coordinatesInput: string[],
  currentItems: RadiusCircle[],
  radius: string
): ValidationResult => {
  const errors: InvalidItemsError[] = [];

  const stringifiedCurrentItems = currentItems.map(item =>
    [parseFloat(item.lat), parseFloat(item.lon), parseFloat(item.rad)].join(',')
  );

  const coordsSet = new Set(stringifiedCurrentItems);
  const validCoordinates: string[] = [];
  const invalidCoordinates: string[] = [];
  const duplicates: string[] = [];

  coordinatesInput.forEach(coords => {
    const [lat, lon, ...extraValues] = splitCoordinates(coords);
    const isCoordinatesValid = validateCoordinates(lat, lon, extraValues);
    const coordsStringified = [lat, lon, radius].join(',');

    if (isCoordinatesValid) {
      if (!coordsSet.has(coordsStringified)) {
        validCoordinates.push(coords);
        coordsSet.add(coordsStringified);
      } else {
        duplicates.push(coords);
      }
    } else {
      invalidCoordinates.push(coords);
    }
  });

  if (duplicates.length)
    errors.push({
      error: t('Duplicates.'),
      invalidItems: duplicates,
    });

  if (invalidCoordinates.length)
    errors.push({
      error: t('Invalid Coordinates.'),
      invalidItems: invalidCoordinates,
    });

  return { errors, validItems: validCoordinates };
};
